import * as actionTypes from './actionTypes'

export const enqueueSnackbar = (notification) => (dispatch) => {
  dispatch({
    type: actionTypes.ENQUEUE_SNACKBAR,
    payload: {
      notification,
    },
  })
}
